"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var styles_1 = __importDefault(require("./styles"));
var Checkbox = function (_a) {
    var onChange = _a.onChange, isHidden = _a.isHidden, value = _a.value, isDisabled = _a.isDisabled, style = _a.style, form = _a.form;
    var _b = react_1.useState(value), isChecked = _b[0], setIsChecked = _b[1];
    var classNames = "checkbox " + (isChecked ? 'checked' : '') + " " + (isDisabled ? 'disabled' : '');
    react_1.useEffect(function () {
        if (form)
            form.addEventListener('reset', setIsChecked.bind(undefined, value));
    }, [form]);
    if (isHidden)
        return null;
    if (value !== isChecked)
        setIsChecked(value);
    var handleChange = function () {
        if (isDisabled || !onChange)
            return;
        var nextIsChecked = !isChecked;
        setIsChecked(nextIsChecked);
        onChange(nextIsChecked);
    };
    return (react_1.default.createElement(styles_1.default, { className: classNames, onClick: handleChange, style: style },
        react_1.default.createElement(Icon_1.default, { className: "icon", icon: "check" })));
};
exports.default = Checkbox;
//# sourceMappingURL=index.js.map